// extracted by mini-css-extract-plugin
export var label = "_hq-2";
export var slideContainer = "_hq-0";
export var slider = "_hq-1";